import {
  ALL_HEALTHCARE_JOB_TITLE_OPTION,
  isAllHealthcareJobTitleOption,
} from './all-healthcare-job-titles';
import {
  ALL_SCHOOLS_JOB_TITLE_OPTION,
  isAllSchoolsJobTitleOption,
} from './all-schools-job-titles';
import { OnOptionsLoad } from './types';

const BULK_JOB_TITLE_OPTIONS = [
  ALL_SCHOOLS_JOB_TITLE_OPTION,
  ALL_HEALTHCARE_JOB_TITLE_OPTION,
] as const;

type JobTitleOptionsResponse = Awaited<ReturnType<OnOptionsLoad>>;

const defaultMeta = {
  currentPage: 1,
  totalPages: 1,
  totalItems: BULK_JOB_TITLE_OPTIONS.length,
  itemsPerPage: 100,
};

export const prependJobTitleBulkOptions = (
  response: JobTitleOptionsResponse,
  search?: string,
): JobTitleOptionsResponse => {
  const trimmedSearch = search?.trim();

  if (trimmedSearch) {
    const existingData = response?.data?.payload?.data ?? [];
    const normalizedSearch = trimmedSearch.toLowerCase();

    const matchingBulkOptions = BULK_JOB_TITLE_OPTIONS.filter((opt) =>
      opt.name.toLowerCase().includes(normalizedSearch),
    );

    if (matchingBulkOptions.length === 0) {
      return response;
    }

    const missingMatchingBulkOptions = matchingBulkOptions.filter(
      (option) =>
        !existingData.some((item) => Number(item.id) === Number(option.id)),
    );

    if (missingMatchingBulkOptions.length === 0) {
      return response;
    }

    return {
      ...response,
      data: response?.data
        ? {
            ...response.data,
            payload: {
              ...response.data.payload,
              data: [...missingMatchingBulkOptions, ...existingData],
            },
          }
        : {
            payload: {
              data: [...missingMatchingBulkOptions],
              meta: defaultMeta,
            },
          },
    };
  }

  const existingData = response?.data?.payload?.data ?? [];

  const missingBulkOptions = BULK_JOB_TITLE_OPTIONS.filter(
    (option) =>
      !existingData.some((item) => Number(item.id) === Number(option.id)),
  );

  if (missingBulkOptions.length === 0) {
    return response;
  }

  if (existingData.length === 0) {
    return {
      ...response,
      data: {
        payload: {
          data: [...BULK_JOB_TITLE_OPTIONS],
          meta: response?.data?.payload?.meta ?? defaultMeta,
        },
      },
    };
  }

  return {
    ...response,
    data: {
      ...response.data,
      payload: {
        ...response.data.payload,
        data: [...missingBulkOptions, ...existingData],
      },
    },
  };
};

export const isSyntheticJobTitleOption = (
  item: { id?: number | string } | null | undefined,
): boolean =>
  isAllSchoolsJobTitleOption(item) || isAllHealthcareJobTitleOption(item);
